<template>
  <div class="dashboard-pie-container">
    <div :id="alias" class="pie-chart" />
    <div class="legends-container">
      <div class="legends-subtitle" v-if="subtitle && chartData?.length">{{ $t(subtitle) }}</div>
      <div
        v-for="(option, optionIndex) of chartData"
        :key="optionIndex"
        class="legend-container"
      >
        <div
          class="legend-color"
          :style="{ 'background-color': option.color }"
        />
        <div class="legend-text">
          {{ $t(option.label) }}: {{ option.value }} ({{ Math.round(100*option.percentage) }}%)
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ChartPie } from "@/utils/ChartPie";
import * as d3 from "d3";

export default {
  name: "DashboardPie",
  props: {
    chartData: {
      type: Array,
      default: () => [],
    },
    alias: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  watch: {
    alias: function (newVal, oldVal) {
      var svg = this.$d3.select("#" + oldVal);
      this.updateChart();
    },
    chartData: function () {
      this.updateChart();
    },
  },
  mounted() {
    d3.select(window).on("resize", () => {
      setTimeout(()=>this.updateChart(),2000)
    });
    this.updateChart();


  },
  methods: {
    updateChart() {
      var svg = this.$d3.select("#" + this.alias);
      svg.selectAll(".chart").remove();
      this.chart = new ChartPie(
        this.alias,
        { data: this.chartData },
        0,
        false,
        {
          top: 0,
          right: 10,
          bottom: 0,
          left: 10,
        }, true,
      );
       this.chart.render()

    },
  },
};
</script>
<style lang="scss" scoped>
.dashboard-pie-container {
  width: 100%;
  display: flex;
  align-items: center;
}

.pie-chart {
  height: 150px;
  width: 150px;
  vertical-align: middle;
  flex-basis: 150px;
  min-width: 150px;
}

.legends-container {
  padding: 0 10px;
  vertical-align: middle;
}
.legend-container {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 5px;
}
.legend-color {
  height: 10px;
  width: 10px;
  border-radius: 15px;
  flex-shrink: 0;
}
.legend-text {
  font-size: 1rem;
  font-family: Poppins-Regular, sans-serif;
}

.legends-subtitle{
  font-family: Poppins-Bold, sans-serif;
  text-transform: uppercase;
}
</style>
